import jp from './jp.json';

const t = jp;

export default t;
